const commonServices = angular.module('commonServices', []);

commonServices.service('userViewService', function (
  eventService
) {

  //defaults
  let view = 'dashboard';
  let originalDashboard = null;
  let previousView = '';

  //view functionalities
  function isCustomizableView() {
    return view === 'dashboard' || view === 'dashboard2' || view === 'trains';
  }

  function getView() {
    return view;
  }

  function setPreviousDashboard(dashboardView) {
    originalDashboard = dashboardView;
  }

  function getPreviousDashboard() {
    return originalDashboard;
  }

  function setView(newView) {
    if (view !== newView) {
      previousView = angular.copy(view);
      view = newView;
    }
    eventService.broadcast('update-view', { view: view });
  }

  function getPreviousView() {
    return previousView;
  }

  return {
    getView: getView,
    setView: setView,
    isCustomizableView: isCustomizableView,
    getPreviousView: getPreviousView,
    setPreviousDashboard: setPreviousDashboard,
    getPreviousDashboard: getPreviousDashboard
  };
});

commonServices.service('chartColorService', function () {
  const availableChartColors = [
    '#1f77b4',
    '#03a858',
    '#6367A9',
    '#dd940b',
    '#820136',
    '#154272',
    '#a96367',
    '#8e99a0',
    '#549E79',
    '#efe370',
    '#201625',
    '#72418F',
    '#ff6699',
    '#99ADC0',
    '#3A2465',
    '#922329',
    '#5B4534',
    '#404E55',
    '#0089A3',
    '#CB7E98',
    '#A4E804',
    '#324E72',
    '#6A3A4C',
    '#000000',
    '#FFFF00',
    '#1CE6FF',
    '#FF34FF',
    '#FF4A46',
    '#008941',
    '#006FA6',
    '#A30059',
    '#FFDBE5',
    '#7A4900',
    '#0000A6',
    '#63FFAC',
    '#B79762',
    '#004D43',
    '#8FB0FF',
    '#997D87',
    '#5A0007',
    '#809693',
    '#1B4400',
    '#4FC601',
    '#3B5DFF',
    '#4A3B53',
    '#FF2F80',
    '#61615A',
    '#BA0900',
    '#6B7900',
    '#00C2A0',
    '#FFAA92',
    '#FF90C9',
    '#B903AA',
    '#D16100',
    '#000035',
    '#7B4F4B',
    '#A1C299',
    '#300018',
    '#0AA6D8',
    '#013349',
    '#00846F',
    '#372101',
    '#FFB500',
    '#C2FFED',
    '#A079BF',
    '#CC0744',
    '#C0B9B2',
    '#C2FF99',
    '#001E09',
    '#00489C',
    '#6F0062',
    '#0CBD66',
    '#EEC3FF',
    '#456D75',
    '#B77B68',
    '#7A87A1',
    '#788D66',
    '#885578',
    '#FAD09F',
    '#FF8A9A',
    '#D157A0',
    '#BEC459',
    '#456648',
    '#0086ED',
    '#886F4C',
    '#34362D',
    '#B4A8BD',
    '#00A6AA',
    '#452C2C',
    '#636375',
    '#A3C8C9',
    '#FF913F',
    '#938A81',
    '#575329',
    '#00FECF',
    '#B05B6F',
    '#8CD0FF',
    '#3B9700',
    '#04F757',
    '#C8A1A1',
    '#1E6E00',
    '#7900D7',
  ];

  const reservedColors = {};

  function getChartColor(id) {
    if (reservedColors[id]) {
      return reservedColors[id];
    } else if (availableChartColors.length > 0) {
      const color = availableChartColors.shift();
      reservedColors[id] = color;
      return color;
    } else {
      return null;
    }
  }

  function fillDataWithColors(data) {
    _.each(data, function (item) {
      const color = getChartColor(item.id);
      if (color) {
        item.color = color;
      }
    });
  }

  function getAllColors() {
    return availableChartColors;
  }

  return {
    getAllColors: getAllColors,
    getChartColor: getChartColor,
    fillDataWithColors: fillDataWithColors,
  };
});

commonServices.service('CommonService', function (stateService) {

  let currentConsist = null;
  let selectedTrain = null;
  let selectedCar = null;

  const setSelectedTrain = selected => selectedTrain = angular.copy(selected);

  const getSelectedTrain = () => selectedTrain;

  const setConsist = consist => currentConsist = angular.copy(consist);

  const getConsist = () => currentConsist;

  const setSelectedCar = selected => selectedCar = angular.copy(selected);

  const getSelectedCar = () => selectedCar;

  const Box = x => ({
    ap: b2 => b2.map(x),
    chain: f => f(x),
    map: f => Box(f(x)),
    fold: f => f(x),
    inspect: () => `Box(${x})`,
  });

  const Right = x => ({
    chain: f => f(x),
    map: f => Right(f(x)),
    fold: (f, g) => g(x),
    inspect: () => `Right(${x})`,
  });

  const Left = x => ({
    chain: f => Left(x),
    map: f => Left(x),
    fold: (f, g) => f(x),
    inspect: () => `Left(${x})`,
  });

  const fromNullable = x => (x != null ? Right(x) : Left(null));

  const checkNullLength = x => ((x != null && x.length > 0) ? Right(x) : Left(null));

  const tryCatch = f => {
    try {
      return Right(f());
    } catch (e) {
      return Left(e);
    }
  };

  const compose = (...fns) => x =>
    fns.reduceRight((acc, fn) => fn(acc), x);

  const pipe = (...fns) => x =>
    fns.reduce((acc, fn) => fn(acc), x);

  const filter = pred => xs => xs.filter(pred);

  const map = cb => array => array.map(cb);

  const prop = key => obj => obj[key];

  const swap = (list, slot1, slot2) => {
    let newList = list;
    let temp = newList[slot2];
    list[slot2] = list[slot1];
    list[slot1] = temp;
    return newList;
  };

  // For safe keeping, needs to be refactored to work as common function
  const chunckAndBatchRender = (hash, collection, size) => {

    const _this = this;
    let promise = $q.resolve();

    function chunkCollection(collection, size) {
      const chunks = [];
      for (let i = 0; i < collection.length; i += size) {
        chunks.push(collection.slice(i, i + size));
      }
      return chunks;
    }

    function scheduleRender(chunk) {
      Array.prototype.push.apply(_this[hash], chunk);
      return $timeout(function () { }, 0);
    }

    const chunked = chunkCollection(collection, size);

    let nextBatch;
    chunked.forEach(function (chunk, index) {
      nextBatch = scheduleRender.bind(null, chunk);
      promise = promise.then(nextBatch);
    });
  };

  const getAudioSegment = segments => {
    return segments.find(({ stream_type }) => stream_type === 'AUDIO');
  };

  const fetchSegmentAudio = async (id, type) => {
    const data = await stateService.getSegmentAudio(id, type);
    if (data.response && data.response.size !== 0) {
      return URL.createObjectURL(data.response);
    }
  };

  const fetchStreamAudio = async (id, sId, macro) => {
    const data = await stateService.getStreamAudio(id, sId, macro);
    if (data.response && data.response.size !== 0) {
      return URL.createObjectURL(data.response);
    }
  };

  const preLoadAudio = segment => {
    if (!segment || !segment.audio) return;
    let filtered = segment.audio.filter(f => f.filename);
    _.each(filtered, file => {
      if (file.filename) {
        fetchSegmentAudio(segment.id, file.audio_type).then(data => {
          file.file_url = data;
        });
      }
    });
    return filtered;
  };

  // Check if collection contains an item with the same name as item given as parameter
  const checkName = (collection, item) => {
    if (!item.name || collection.length === 0) return;
    return collection.find(c => c.name.toLowerCase() === item.name.toLowerCase()) ? true: false;
  };

  const preLoadStream = (workSpaceId, stream, macro) => {
    if (!stream) return;
    return fetchStreamAudio(workSpaceId, stream.id, macro).then(data => data);
  };

  const getMacroList = async (id) => {
    let allAudioStation = stateService.getAllAudioStation();
    // If there is no station with all audio uploaded (=linked), use default station Oxford Circus (id: 117)
    if (allAudioStation === undefined) {
      allAudioStation = { id: 117 };
    }

    let data = await stateService.getVariables(id);
    // Using lodash find here, because js find results an error "data.find is not a function"
    data = _.find(data, function(variable) {
      return variable.type !== 'system'
    });

    let macroList = [];
    _.each(data.macro_variables, macro => {
      macroList.push({name: macro, id: allAudioStation.id});
    });
    return macroList;
  };

  // installTypeMapper :: (Integer) -> String 
  const installTypeMapper = type => {
    const types = {
      0: 'Not in use',
      1: 'Local install',
      2: 'Remote install',
      3: 'Auto Activation',
      4: 'Silent Update',
      999: 'Unknown type'
    };
    return types[type] || types[999];
  };

  return {
    setSelectedTrain: setSelectedTrain,
    getSelectedTrain: getSelectedTrain,
    setSelectedCar: setSelectedCar,
    getSelectedCar: getSelectedCar,
    setConsist: setConsist,
    getConsist: getConsist,
    Box: Box,
    Right: Right,
    Left: Left,
    fromNullable: fromNullable,
    checkNullLength: checkNullLength,
    tryCatch: tryCatch,
    compose: compose,
    pipe: pipe,
    filter: filter,
    map: map,
    prop: prop,
    swap: swap,
    chunckAndBatchRender: chunckAndBatchRender,
    getAudioSegment: getAudioSegment,
    preLoadAudio: preLoadAudio,
    preLoadStream: preLoadStream,
    getMacroList: getMacroList,
    checkName: checkName,
    installTypeMapper: installTypeMapper,
  };
});

commonServices.service('DescriptorService', function () {

  const getPackageHeader = pkg => {
    let header = JSON.parse(pkg.header);
    return header.header;
  };

  return {
    getPackageHeader: getPackageHeader,
  };
});
